import { render, staticRenderFns } from "./DataGridBannerMasterDetail.vue?vue&type=template&id=7bb10a60"
import script from "./DataGridBannerMasterDetail.vue?vue&type=script&lang=js"
export * from "./DataGridBannerMasterDetail.vue?vue&type=script&lang=js"
import style0 from "./DataGridBannerMasterDetail.vue?vue&type=style&index=0&id=7bb10a60&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports